import type { SentFromEmailCondition as SentFromEmailConditionType } from "@redotech/redo-model/advanced-flow/rules/schemas";
import { RedoTagInputField } from "@redotech/redo-web/arbiter-components/input/redo-tag-input-field";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useState } from "react";

export const SentFromEmailCondition = memo(function SentFromEmailCondition({
  condition,
  onChange,
}: {
  condition: SentFromEmailConditionType;
  onChange: (updated: SentFromEmailConditionType) => void;
}) {
  const [inputValue, setInputValue] = useState("");

  return (
    <Flex dir="column" gap="md" w="full">
      <RedoTagInputField
        inputValue={inputValue}
        label="Sender email address(es)"
        placeholder="Enter email addresses"
        setInputValue={setInputValue}
        setTags={(emails) => {
          const uniqueEmails = Array.from(new Set(emails));
          onChange({ ...condition, emails: uniqueEmails });
        }}
        state="default"
        tags={(condition.emails || []).map((email) => ({ text: email }))}
      />
    </Flex>
  );
});
